import React, { Component, useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { conf } from '../../confg';
import axios from 'axios';
import { BRAND_NAME_EN, BRAND_NAME } from '../../themeSetting.js';

const HeadMeta = ({ tabTitle, children = <></>, description = BRAND_NAME }) => {
  const [logo, setLogo] = useState();

  useEffect(() => {
    axios({
      url: conf.server_url + 'detail',
      method: 'GET',
      headers: {
        Accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    }).then(response => {
      if (response?.data?.website_logo) {
        console.log('response.data.website_logo', response.data.website_logo);
        setLogo(response.data.website_logo);
      }
    });
  }, []);

  return (
    <Helmet>
      <title>
        {tabTitle} | {BRAND_NAME_EN}
      </title>
      <meta name='description' content={description} />

      <meta name='google-site-verification' content='qGGCXrPiLiv9dDSjW2_BSKaizRD6eTQrWGqXITfi47Q' />
      <meta name='theme-color' content='#000000' />
      <meta charSet='utf-8' />
      <meta name='viewport' content='width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0' />

      <meta property='og:url' content={`https://sadatijewellery.com${window.location.pathname}`} />
      <meta property='og:type' content='website' />
      <meta property='og:title' content={`${tabTitle} - ${BRAND_NAME_EN}`} />
      <meta property='og:description' content={description} />
      <meta property='og:image' content={logo} />
      <meta property='og:image:alt' content={tabTitle} />
      <meta property='og:image:type' content='image/jpeg' />
      <meta property='og:image:width' content='1200' />
      <meta property='og:image:height' content='1000' />

      {/*<meta name='twitter:card' content='summary_large_image' />*/}
      {/*<meta property='twitter:domain' content='rezvanjewellery.com' />*/}
      {/*<meta property='twitter:url' content={`https://rezvanjewellery.com${window.location.pathname}`} />*/}
      {/* <meta name='twitter:title' content={`${tabTitle} - ${BRAND_NAME}`} /> */}
      {/*<meta name='twitter:description' content={description} />*/}
      {/*<meta name='twitter:image' content={image} />*/}

      {children}
    </Helmet>
  );
};

export default HeadMeta;
